module.exports = __webpack_public_path__ + "kh.ae60a7f6.svg";